import React, { FC, memo, useMemo } from 'react';

import Select from '@zvuk-b2b/react-uikit/ui/Select';
import IconChevronDown from '@zvuk-b2b/react-uikit/ui/icons/ChevronDown';
import type { DropdownItemDataType } from '@zvuk-b2b/react-uikit/ui/Dropdown';

import { AUDIO_REPORT_SCOPE_OPTIONS, DATA_TEST_IDS } from '../consts';
import { TEXTS } from '../texts';
import { AUDIO_REPORT_SCOPE, type AudioReportScopeType } from '../types';
import type { AddressReportTypeSelectProps } from './types';

import styles from './index.module.scss';

const SCOPE_TITLE_BY_VALUE: Record<AudioReportScopeType, string> = {
  [AUDIO_REPORT_SCOPE.COMMON]: TEXTS.AUDIO_REPORT_SCOPE_COMMON,
  [AUDIO_REPORT_SCOPE.ADDRESSES]: TEXTS.AUDIO_REPORT_SCOPE_ADDRESSES,
};

const AddressReportTypeSelect: FC<AddressReportTypeSelectProps> = ({ value, onChange }) => {
  const options = useMemo<DropdownItemDataType[]>(
    () =>
      AUDIO_REPORT_SCOPE_OPTIONS.map((scope) => ({
        key: DATA_TEST_IDS.AUDIO_REPORT_SCOPE_OPTION(scope),
        value: scope,
        content: SCOPE_TITLE_BY_VALUE[scope],
        selected: scope === value,
        onClick: () => onChange(scope),
      })),
    [onChange, value]
  );

  return (
    <div
      className={styles.container}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_SCOPE}>
      <Select
        elementId={DATA_TEST_IDS.AUDIO_REPORT_SCOPE_SELECT}
        label={TEXTS.AUDIO_REPORT_SCOPE_LABEL}
        value={SCOPE_TITLE_BY_VALUE[value]}
        options={options}
        useFullMode={false}
        className={styles.container}
        buttonClassName={styles.button}
        buttonOpenClassName={styles.buttonOpen}
        dropdownItemContentClassName={styles.option}
        dropdownItemContentSelectedClassName={styles.optionSelected}
        adornmentRight={
          <span
            className={styles.icon}
            data-testid={DATA_TEST_IDS.AUDIO_REPORT_SCOPE_ICON}>
            <IconChevronDown />
          </span>
        }
      />
    </div>
  );
};

export default memo(AddressReportTypeSelect);
